import {RouteComponentProps} from "react-router";
import {Button, Col, Form, FormInstance, Input, InputNumber, message, Modal, ModalProps, Row, Space} from "antd";
import React, {useEffect, useState} from "react";
import {useForm, useWatch} from "antd/lib/form/Form";
import DictSelect from "../DictSelect";
import Select from "../Select";
import * as api from "../../apis/product";

import styles from "./index.module.css";
import {NamePath, InternalNamePath} from "antd/lib/form/interface";
import ProductSelectModal from "../ProductSelectModal";
import {useRequest} from "ahooks";


interface GiveawayRulesModalProps extends ModalProps {
    form: FormInstance
    enableModify: boolean
    prefixNamePath?: NamePath
    permissionEnable?:boolean
}

function GiveawayRulesModal(props: GiveawayRulesModalProps) {
    const [giveawayForm] = useForm();
    const [namePath, setNamePath] = useState<NamePath>('giveaways');
    const [productSelectModalVisible, setProductSelectModalVisible] = useState<Array<any> | boolean>(false);
    const [products, setProducts] = useState<any>({});
    const [enableModify, setEnableModify] = useState(false);
    const giveaways = useWatch('giveaways', giveawayForm);

    const {loading: loadingProduct} = useRequest(api.getAllProducts, {
        manual: false,
        onSuccess(res) {
            const p:any = {};
            res.data.data?.forEach((item:any)=>{
                p[item.id] = item.code;
            });
            setProducts(p);
        }
    });

    useEffect(() => {
        if (props.open) {
            giveawayForm.resetFields();
            const allRules = props.form.getFieldValue(namePath);
            giveawayForm.setFieldValue('giveaways', allRules);
            allRules?.forEach((r:any, i:number)=>{
                giveawayForm.setFieldValue(['giveaways',i,'giveaway1Name'],products[r.giveaway1])
                giveawayForm.setFieldValue(['giveaways',i,'giveaway2Name'],products[r.giveaway2])
                giveawayForm.setFieldValue(['giveaways',i,'giveaway3Name'],products[r.giveaway3])
            })
        }
    }, [props.open]);

    useEffect(() => {
        giveawayForm.resetFields();
        const allRules = props.form.getFieldValue(namePath);
        giveawayForm.setFieldValue('giveaways', allRules);
        allRules?.forEach((r:any, i:number)=>{
            giveawayForm.setFieldValue(['giveaways',i,'giveaway1Name'],products[r.giveaway1])
            giveawayForm.setFieldValue(['giveaways',i,'giveaway2Name'],products[r.giveaway2])
            giveawayForm.setFieldValue(['giveaways',i,'giveaway3Name'],products[r.giveaway3])
        })
    }, [namePath]);

    useEffect(() => {
        const prefix = props.prefixNamePath;
        setNamePath(prefix ? [prefix, 'giveaways'].flat() : 'giveaways');
    }, [props.prefixNamePath]);


    const onOk = (e: any) => {
        giveawayForm.validateFields().then(() => {
            props.form.setFieldValue(namePath, giveawayForm.getFieldValue('giveaways'));
            giveawayForm.resetFields();
            props.onOk?.(e);
        })
    }
    const onCancel = (e: any) => {
        // giveawayForm.resetFields();
        props.onCancel?.(e);
    }

    const onClear = (e: any) => {
        giveawayForm.setFieldValue('giveaways', []);
    }

    useEffect(()=>{
        if(props.permissionEnable===undefined){
            setEnableModify(props.enableModify)
        }else{
            setEnableModify(props.permissionEnable && props.enableModify)
        }
    },[props.enableModify, props.permissionEnable]);

    const footer = [
        <Button onClick={onOk} type={"primary"} key={'ok'} disabled={!enableModify}>确定</Button>,
        <Button onClick={onClear} type={"primary"} key={'clear'} disabled={!enableModify}>清除</Button>,
        <Button onClick={onCancel} key={'cancel'}>取消</Button>,
    ];

    const handleProductSelected = (keys?: Array<number>, records?: Array<any>) => {
        if (!!records?.length && Array.isArray(productSelectModalVisible)) {
            const product = records[0];
            giveawayForm.setFieldValue(['giveaways', ...productSelectModalVisible], product.id);
            const nameP = [...productSelectModalVisible];
            nameP[nameP.length-1]+='Name';
            giveawayForm.setFieldValue(['giveaways', ...nameP], product.name);
        }
        setProductSelectModalVisible(false);
    }


    return <Modal title={'满赠规则列表'} width={1200} {...props} destroyOnClose footer={footer}
                  className={styles.GiveawayModal}>
        <Form form={giveawayForm} disabled={!props.enableModify}>
            <Form.List name={'giveaways'}>
                {(fields, {add, remove}) => (
                    <>
                        <Row className={styles.labelsContainer}>
                            <Col span={2}/>
                            <Col span={4}><label className={styles.required}>赠送方式</label></Col>
                            <Col span={2}><label className={styles.required}>满</label></Col>
                            <Col span={2}><label className={styles.required}>送</label></Col>
                            <Col span={4}><label className={styles.required}>赠品1</label></Col>
                            <Col span={4}><label>赠品2</label></Col>
                            <Col span={4}><label>赠品3</label></Col>
                        </Row>
                        {
                            fields.map((f, i) => (
                                <Row>
                                    <Form.Item name={[f.name, 'id']} key={f.key} noStyle/>
                                    {/*<Form.Item name={[f.name, 'productId']} key={f.key}*/}
                                    {/*           initialValue={props.form.getFieldValue('id')} noStyle/>*/}
                                    <Col span={2}>
                                        <Space>
                                            <Button onClick={() => {
                                                remove(f.name);
                                                console.log(fields.length);
                                            }}>-</Button>
                                            <Button onClick={() => add(f.name)}>+</Button>
                                        </Space>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item name={[f.name, 'type']} key={f.key}
                                                   rules={[{required: true, message: '请填写必填项'}]}>
                                            <DictSelect dict={'GiveawaysType'} appendNull={false}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={2}>
                                        <Form.Item name={[f.name, 'satisfy']} key={f.key}
                                                   rules={[{required: true, message: '请填写必填项'}]}>
                                            <InputNumber/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={2}>
                                        <Form.Item name={[f.name, 'give']} key={f.key}
                                                   rules={[{required: true, message: '请填写必填项'}]}>
                                            <InputNumber/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item name={[f.name, 'giveaway1']} key={f.key}
                                                   rules={[{required: true, message: '请填写必填项'}]} noStyle/>
                                            <Form.Item name={[f.name, 'giveaway1Name']}>
                                                <Input
                                                    readOnly addonAfter={<a
                                                    onClick={() => setProductSelectModalVisible([f.name, 'giveaway1'])}>选取</a>}/>
                                            </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item name={[f.name, 'giveaway2']} key={f.key} noStyle/>
                                            <Form.Item name={[f.name, 'giveaway2Name']}>
                                                <Input
                                                    readOnly addonAfter={<a
                                                    onClick={() => setProductSelectModalVisible([f.name, 'giveaway2'])}>选取</a>}/>
                                            </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item name={[f.name, 'giveaway3']} key={f.key} noStyle/>
                                            <Form.Item name={[f.name, 'giveaway3Name']}>
                                                <Input
                                                    readOnly addonAfter={<a
                                                    onClick={() => setProductSelectModalVisible([f.name, 'giveaway3'])}>选取</a>}/>
                                            </Form.Item>

                                    </Col>
                                </Row>
                            ))
                        }
                        {fields.length > 0 ? null : <Button onClick={() => add()}>+</Button>}
                    </>
                )}
            </Form.List>
        </Form>
        <ProductSelectModal multiple={false} open={!!productSelectModalVisible}
                            onCancel={() => setProductSelectModalVisible(false)} onComplete={handleProductSelected}/>
    </Modal>
}

export default GiveawayRulesModal;